import { Navigate } from "react-router-dom";
import { CircleNotch } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center text-[#A1A1AA]">
        <CircleNotch size={28} className="animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
